export default __webpack_public_path__ + "static/media/testi-home7.ba1296fe.jpg";